import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "content", "customImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Modal, Text } from 'hoi-poi-ui';
import Illustrations from "./components/Illustrations";
import styles from "./styles/ModalDisableAddOn";
const {
  DisableAddOn
} = Illustrations;
const useStyles = createUseStyles(styles, 'ModalDisableAddOn');
const ModalDisableAddOn = /*#__PURE__*/memo(_ref => {
  let {
      children,
      content,
      customImage
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const modalProps = useMemo(() => {
    return _objectSpread({
      size: 'small'
    }, props);
  }, [props]);
  const Img = useMemo(() => customImage || DisableAddOn, [customImage]);
  return /*#__PURE__*/React.createElement(Modal, modalProps, /*#__PURE__*/React.createElement("figure", {
    className: classes.figure
  }, /*#__PURE__*/React.createElement(Img, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, (content === null || content === void 0 ? void 0 : content.length) && content.map((text, index) => /*#__PURE__*/React.createElement(Text, {
    type: "body",
    key: index
  }, text))));
});
process.env.NODE_ENV !== "production" ? ModalDisableAddOn.propTypes = {
  content: PropTypes.arrayOf(PropTypes.string),
  customImage: PropTypes.node,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
} : void 0;
export default ModalDisableAddOn;